import request from "@/utils/request";
const { ElMessage, ElMessageBox } = require("element-plus");

export default {
  name: "ApplyRepairInfo",
  data() {
    return {
      loading: true,
      dialogVisible: false,
      detailDialog: false,
      search: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      detail: {},
      isMobile: false,
      user: {},
      room: {
        dormRoomId: '',
        dormBuildId: '',
      },
      form: {
        title: '',
        dormBuildId: '',
        dormRoomId: '',
        repairer: '',
        content: '',
        username: '',
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },
    };
  },
  created() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
    this.init();
    this.load();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    init() {
      try {
        this.user = JSON.parse(sessionStorage.getItem("user")) || {};
      } catch (e) {
        this.user = {};
      }
      this.form.repairer = this.user.name || '';
      this.form.username = this.user.username || '';
      this.getRoomInfo();
    },
    getRoomInfo() {
      if (!this.form.username) return;
      request.get("/room/getMyRoom/" + this.form.username).then((res) => {
        if (res.code === "0" && res.data) {
          this.room = res.data;
          this.form.dormBuildId = res.data.dormBuildId;
          this.form.dormRoomId = res.data.dormRoomId;
        }
      });
    },
    async load() {
      this.loading = true;
      try {
        const res = await request.get("/repair/find/" + (this.user.name || ''), {
          params: {
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            search: this.search,
          },
        });
        this.tableData = res.data.records || [];
        this.total = res.data.total || 0;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },
    filterTag(value, row) {
      return row.state === value;
    },
    showDetail(row) {
      this.detail = { ...row };
      this.detailDialog = true;
    },
    closeDetails() {
      this.detailDialog = false;
    },
    add() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.resetFields();
        this.form.title = '';
        this.form.content = '';
        this.form.repairer = this.user.name || '';
        this.form.username = this.user.username || '';
        this.form.dormBuildId = this.room.dormBuildId || '';
        this.form.dormRoomId = this.room.dormRoomId || '';
      });
    },
    save() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;
        try {
          const res = await request.post("/repair/add", this.form);
          if (res.code === "0") {
            ElMessage({ message: "提交成功", type: "success" });
            this.search = "";
            this.load();
            this.dialogVisible = false;
          } else {
            ElMessage({ message: res.msg || "提交失败", type: "error" });
          }
        } catch (e) {
          ElMessage({ message: "网络错误", type: "error" });
        }
      });
    },
    cancel() {
      this.$refs.formRef && this.$refs.formRef.resetFields();
      this.dialogVisible = false;
    },
    formatRoomLabel() {
      if (this.room.dormBuildId && this.room.dormRoomId) {
        return this.room.dormBuildId + '栋 - ' + this.room.dormRoomId + '号房';
      }
      return '未分配房间';
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.load();
    },
    handleCurrentChange(pageNum) {
      this.currentPage = pageNum;
      this.load();
    },
  },
};
